import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Grid,
    Typography,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import UploadImage from "../../../components/images/UploadImage";
import { useState } from "react";
import DeliveryImages from "../../../components/delivery/DeliveryImages";

// Validación con Yup
const companySchema = yup.object().shape({
    name: yup.string().required("Nombre requerido"),
    address: yup.string(),
    zip: yup.string(),
    state: yup.string(),
    phone: yup
        .number()
        .typeError("Debe ser un número")
        .positive("Debe ser positivo")
        .integer("Debe ser un número entero")
        .nullable(),
    //image: yup.mixed(),
});

const CompanyDialog = ({ open, onClose, item = null, onSave, mostrarErrorRequest }) => {
    const isEdit = Boolean(item?.id);

    const [images, setImages] = useState([]);
    const [previews, setPreviews] = useState([]);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            if(images.length > 0) {
                values.base64_image = images[0];
            }
            console.log('cambio creando empresa', values)
            await onSave(values);
            onClose();
        } catch (err) {
            console.error("Error al guardar empresa:", err);
        } finally {
            setSubmitting(false);
        }
    };

    const onCloseDialog = () => {
        setImages([]);
        setPreviews([]);
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEdit ? "Editar Empresa" : "Crear Empresa"}</DialogTitle>
            <Formik
                initialValues={{
                    id: item?.id || null,
                    name: item?.name || "",
                    address: item?.address || "",
                    zip: item?.zip || "",
                    state: item?.state || "",
                    phone: item?.phone || "",
                    image: item?.image,
                    base64_image: null,
                }}
                validationSchema={companySchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    touched,
                    errors,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent sx={{ display: "grid", gap: 2 }}>
                            <TextField
                                label="Nombre *"
                                name="name"
                                fullWidth
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!touched.name && !!errors.name}
                                helperText={touched.name && errors.name}
                            />

                            <TextField
                                label="Dirección"
                                name="address"
                                fullWidth
                                value={values.address}
                                onChange={handleChange}
                            />

                            <TextField
                                label="Código Postal"
                                name="zip"
                                fullWidth
                                value={values.zip}
                                onChange={handleChange}
                            />

                            <TextField
                                label="Estado"
                                name="state"
                                fullWidth
                                value={values.state}
                                onChange={handleChange}
                            />

                            <TextField
                                label="Teléfono"
                                name="phone"
                                fullWidth
                                value={values.phone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!touched.phone && !!errors.phone}
                                helperText={touched.phone && errors.phone}
                            />

                            <Box>
                                <Grid item>
                                    <UploadImage
                                        images={images}
                                        setImages={setImages}
                                        setPreviews={setPreviews}
                                        mostrarErrorRequest={mostrarErrorRequest}
                                        minimo={1}
                                        max={1}
                                        textBotton="Seleccionar nuevo logo"
                                    />
                                </Grid>

                                {previews.length > 0 && (
                                    <DeliveryImages images={previews} title="Vista previa del nuevo logo" imgHeight={200} />
                                )}

                                {item && (
                                    <Box>
                                        {item.image && (
                                            <Box mt={2}>
                                                <Typography variant="subtitle1">Logo actual:</Typography>
                                                <img src={item.image} alt="Imagen Entregada 1" style={{ maxWidth: '100%', height: '200' }} />
                                            </Box>
                                        )}
                                    </Box>
                                )}

                            </Box>
                        </DialogContent>

                        <DialogActions>
                            <Button color="inherit" onClick={()=>{onCloseDialog()}}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                               
                            >
                                {isEdit ? "Actualizar" : "Crear"}
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};

export default CompanyDialog;
